module.exports = __webpack_public_path__ + "static/media/logo2.d53a35ad.png";